import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import s from "../core/Accessor.js";
import r from "../core/Collection.js";
import { init as o } from "../core/watchUtils.js";
import { property as t } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as i } from "../core/accessorSupport/decorators/subclass.js";

var a = /*#__PURE__*/function (_s) {
  _inherits(a, _s);

  var _super = _createSuper(a);

  function a(e) {
    var _this;

    _classCallCheck(this, a);

    _this = _super.call(this, e), _this.view = null, _this.baseLayerViews = new r(), _this.referenceLayerViews = new r(), _this._loadingHandle = o(_assertThisInitialized(_this), "view.map.basemap", function (e) {
      e && e.load().catch(function () {});
    });
    return _this;
  }

  _createClass(a, [{
    key: "destroy",
    value: function destroy() {
      this._set("view", null), this._loadingHandle && (this._loadingHandle.remove(), this._loadingHandle = null);
    }
  }, {
    key: "suspended",
    get: function get() {
      return !this.view || this.view.suspended;
    }
  }, {
    key: "updating",
    get: function get() {
      return (!this.view || !this.view.suspended) && !(!(this.view && this.view.map && this.view.map.basemap) || this.view.map.basemap.loaded);
    }
  }]);

  return a;
}(s);

e([t({
  constructOnly: !0
})], a.prototype, "view", void 0), e([t({
  readOnly: !0
})], a.prototype, "baseLayerViews", void 0), e([t({
  readOnly: !0
})], a.prototype, "referenceLayerViews", void 0), e([t({
  readOnly: !0
})], a.prototype, "suspended", null), e([t({
  type: Boolean,
  readOnly: !0
})], a.prototype, "updating", null), a = e([i("esri.views.BasemapView")], a);
export { a as BasemapView };